import React from "react";
import { FaPause } from "react-icons/fa";
import { IoMdPlayCircle } from "react-icons/io";
import { cn } from "~/lib/utils";

interface MediaControlButtonProps {
  mediaType: "video" | "audio";
  isPlaying?: boolean;
  disabled?: boolean;
  onPlay: () => void;
  onPause?: () => void;
  playlistLength?: number;
  isMobile?: boolean;
  isTrackView?: boolean;
}

const MediaControlButton: React.FC<MediaControlButtonProps> = ({
  mediaType,
  isPlaying = false,
  disabled = false,
  onPlay,
  onPause,
  playlistLength = 0,
  isMobile = false,
  isTrackView = false,
}) => {
  const isDisabled = disabled || playlistLength < 1;

  const handleClick = () => {
    if (mediaType === "audio" && isPlaying && onPause) {
      onPause();
    } else {
      onPlay();
    }
  };

  const getButtonContent = () => {
    if (mediaType === "audio") {
      if (isPlaying) {
        return <FaPause size={35} className="text-[#bd5629] drop-shadow-lg" />;
      } else {
        return <IoMdPlayCircle size={40} className="text-[#bd5629]  drop-shadow-lg" />;
      }
    } else {
      // Video type
      return <IoMdPlayCircle size={40} className="text-[#bd5629] drop-shadow-lg" />;
    }
  };

  return (
    <div className="absolute inset-0 flex items-center justify-center transition-all duration-300">
      {/* On mobile audio, only show pause button when playing */}

      {/* {isMobile && mediaType === "audio" && !isPlaying ? null : ( */}
      <button
        disabled={isDisabled}
        onClick={handleClick}
        title={isDisabled ? `No ${mediaType} available` : isPlaying ? "Pause" : "Play"}
        className={cn(
          "flex items-center justify-center rounded-full transform transition-all duration-300  ",
          isMobile || isTrackView
            ? "opacity-100 p-3" // Always visible on mobile
            : "opacity-0 group-hover:opacity-100 group-hover:scale-110 p-3", // Hover behavior on desktop
          {
            "cursor-not-allowed": isDisabled,
          },
        )}
      >
        {getButtonContent()}
      </button>
      {/* )} */}
    </div>
  );
};

export default MediaControlButton;
